import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { Form, Input } from '@shared/components';
import { intl } from '@shared/localization';

import { detailModes } from '../../../constants';
import { selectedLongCruiseSel } from '../../../duck';
import { formatPlaceholder } from '../utils/longCruiseFormatter';

const FormItem = Form.Item;

const LongCruiseName = ({ form, disabled, className, detailMode }) => {
  const { selectedLongCruiseName } = useSelector(selectedLongCruiseSel) || {};

  const uniqueNameValidator = (rule, value, cb) => {
    if (rule.uniqueName && selectedLongCruiseName === value) {
      return cb(intl.formatMessage({ id: 'longCruise.control.uniqueName' }));
    }
    cb();
  };

  const { getFieldDecorator } = form;

  return (
    <FormItem required className={className}>
      {getFieldDecorator('name', {
        rules: [
          {
            uniqueName: detailMode === detailModes.CLONE,
            validator: uniqueNameValidator,
          },
          {
            required: true,
            message: intl.formatMessage({
              id: 'shared.form.error.isRequired',
            }),
          },
          {
            max: 50,
            message: intl.formatMessage(
              {
                id: 'shared.maxCharacters',
              },
              {
                max: 50,
              },
            ),
          },
        ],
      })(
        <Input
          disabled={disabled}
          size="large"
          placeholder={formatPlaceholder('name')}
          rounded
          floatingLabel
        />,
      )}
    </FormItem>
  );
};

LongCruiseName.propTypes = {
  form: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  detailMode: PropTypes.string,
};

export default LongCruiseName;
